export default "__VITE_ASSET__CaXh0Bgq__"